import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fxv-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const choice = localStorage.getItem(KEY);
      if (!choice) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-white border border-[#E2E8F0] shadow-[0_20px_60px_rgba(12,35,64,0.15)] p-6"
    >
      <p className="font-serif text-xl text-[#0C2340]">Respect de votre vie privée</p>
      <p className="text-sm text-[#4A5568] mt-2 leading-relaxed">
        Ce site utilise uniquement des cookies nécessaires à son bon
        fonctionnement et des outils de mesure d'audience anonymisée,
        conformément au RGPD.{" "}
        <Link to="/confidentialite" className="underline hover:text-[#0C2340]">
          En savoir plus
        </Link>
        .
      </p>
      <div className="mt-4 flex gap-3">
        <button
          data-testid="cookie-accept"
          onClick={() => choose("accepted")}
          className="rounded-full bg-[#0C2340] text-white px-5 py-2.5 text-sm hover:bg-[#163861]"
        >
          Accepter
        </button>
        <button
          data-testid="cookie-reject"
          onClick={() => choose("rejected")}
          className="rounded-full border border-[#E2E8F0] text-[#0C2340] px-5 py-2.5 text-sm hover:border-[#0C2340]"
        >
          Refuser
        </button>
      </div>
    </div>
  );
}
